/* eslint-disable no-control-regex*/
export const nonAsciiRegex = /[^\x00-\x7F]+/g; // All non-ascii characters
export const controlRegex = /[\x00-\x09\x0B\x0C\x0E-\x1F\x7F]/g; // 00-1F and 7F, excl new-line chars
// eslint-disable-next-line
export const postcodeRegex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/;
export const emailAddressRegex = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,64}$/;
